import { GridInputs } from "../../../../../components/Functional";

const Jobs = props => {
  const { formik } = props || {};

  const inputs = {
    className:
      "mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 lg:gap-16",
    inputs: [
      {
        className: "flex flex-col gap-4",
        inputs: [
          {
            label: "Job #",
            name: "_jobItem.jobId",
            type: "number",
          },
        ],
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return <GridInputs {...gridInputProps} />;
};

export default Jobs;
